import type { ConfidenceBarProps } from '@ecomm/scout'
import type { Locale } from '@ecomm/utils'

import type { NhwWrappedSchema } from '@ecomm/home-landing-data'

const confidenceBarData: Record<Locale, ConfidenceBarProps['listItems']> = {
  'en-US': [
    {
      headline:
        'Professional monitoring starting at less than $1/day & your first month free',
      body: '',
      icon: 'SupportIcon'
    },
    {
      headline: 'Easy to install yourself or choose optional pro install',
      body: '',
      icon: 'SecureHomeIcon'
    },
    {
      headline: 'Complete control with the SimpliSafe® App',
      body: '',
      icon: 'CellphoneIcon'
    },
    {
      headline: '60-day money-back guarantee with free return shipping',
      body: '',
      icon: 'SecureCheckmarkIcon'
    }
  ],
  'en-GB': [
    {
      headline: 'Professional monitoring under 53p/day & your first month free',
      body: '',
      icon: 'SupportIcon'
    },
    {
      headline: 'Easy to install yourself or choose optional pro install',
      body: '',
      icon: 'SecureHomeIcon'
    },
    {
      headline: 'Complete control with the SimpliSafe® App',
      body: '',
      icon: 'CellphoneIcon'
    },
    {
      headline: '60-day money-back guarantee with free return shipping',
      body: '',
      icon: 'SecureCheckmarkIcon'
    }
  ]
}

export const getConfidenceBarData = (locale: Locale) =>
  confidenceBarData[locale]

export const userReviewsData = [
  {
    name: 'John A.',
    text: '“The system scared the burglar away, and kept him away from our family upstairs. They caught the burglar 4 hours later. With this video, the police can secure the proof that this was him.”'
  },
  {
    name: 'Laura E.',
    text: '“I just switched from a security company I will not name. I am extremely pleased.”'
  },
  {
    name: 'Crystal M.',
    text: '“Easiest. Thing. I. Have. Ever. Installed.”'
  },
  {
    name: 'Richard M.',
    text: '"This system just works. Zero complaints.”'
  }
]

const findByContentfulId = (
  contentfulId: string,
  images: NhwWrappedSchema['expertReviewsAssets']['items']
) => {
  /* istanbul ignore next */
  return images.find(element => element.sys.id === contentfulId)
}

export const getAppWidgetData = (
  images: NhwWrappedSchema['expertReviewsAssets']['items'],
  locale: Locale
) => {
  const appWidgetData = {
    'en-US': [
      {
        tab: 'Cameras',
        title: 'Keep watch indoors and out with live camera feeds',
        list: [
          'Crisp, HD video with night vision',
          'Unlimited 30-day cloud storage of recordings*',
          '2-way audio on indoor and outdoor cameras',
          'Smart motion detection instantly alerts you of activity'
        ],
        image: findByContentfulId('ZYB8WxMtOe454lse5FG2D', images),
        disclaimer: ['*For up to 10 cameras. Monitoring plan required.']
      },
      {
        tab: 'Controls',
        title: 'Protect your home from anywhere',
        list: [
          'Arm and disarm from anywhere',
          'Lock and unlock Smart Locks',
          'Check temperature sensors'
        ],
        image: findByContentfulId('6rmX3DElVdPZn4Hw3JNqV9', images)
      },
      {
        tab: 'Alarms',
        title: 'Get notified instantly of unusual activity',
        list: [
          'Receive an immediate notification when motion is detected',
          'Cancel an alarm using the app, keypad, or text message*',
          'Monitor against break-ins, fires, floods and more',
          'SimpliSafe® agents call to verify alarms**'
        ],
        disclaimer: [
          '*Monitoring plan required to cancel by text message.',
          '**Professional monitoring plan required.'
        ],
        image: findByContentfulId('4ju8RHivPNhZIeWF0WJ75X', images)
      },
      {
        tab: 'Doorbell',
        title: 'See who’s at the door',
        list: [
          'See and speak to visitors at the door',
          'Communicate safely from home or away',
          'Capture evidence of porch pirates*'
        ],
        disclaimer: ['*Monitoring plan with camera recordings is required.'],
        image: findByContentfulId('38iheGuzSVg8kPQ1aokAnw', images)
      }
    ],
    'en-GB': [
      {
        tab: 'Cameras',
        title: 'Keep watch indoors and out with live camera feeds',
        list: [
          'Crisp, HD video with night vision',
          'Unlimited 30-day cloud storage of recordings*',
          '2-way audio on indoor and outdoor cameras',
          'Smart motion detection instantly alerts you of activity'
        ],
        image: findByContentfulId('ZYB8WxMtOe454lse5FG2D', images),
        disclaimer: ['*For up to 10 cameras. Monitoring plan required.']
      },
      {
        tab: 'Controls',
        title: 'Protect your home from anywhere',
        list: ['Arm and disarm from anywhere', 'Check temperature sensors'],
        image: findByContentfulId('6LT6dvk157aAfFdKyeG2Kf', images)
      },
      {
        tab: 'Alerts',
        title: 'Get notified instantly of unusual activity',
        list: [
          'Receive an immediate notification when motion is detected',
          'Cancel an alarm using the app, keypad, or text message*',
          'Monitor against break-ins, fires, floods and more',
          'SimpliSafe® agents call to verify alarms**'
        ],
        disclaimer: [
          '*Monitoring plan required to cancel by text message.',
          '**Professional monitoring plan required.'
        ],
        image: findByContentfulId('50wlqz44dQwAzOoxzmPO90', images)
      },
      {
        tab: 'Doorbell',
        title: 'See who’s at the door',
        list: [
          'See and speak to visitors at the door',
          'Communicate safely from home or away',
          'Capture evidence of porch pirates*'
        ],
        disclaimer: ['*Monitoring plan with camera recordings is required.'],
        image: findByContentfulId('38iheGuzSVg8kPQ1aokAnw', images)
      }
    ]
  }

  return appWidgetData[locale]
}
